/* tslint:disable */

declare var Object: any;
export interface ViewEmpOvtReportInterface {
  "attendId": string;
  "empId": string;
  "name"?: string;
  "posName": string;
  "otDate": Date;
  "shiftdailyCode": string;
  "shiftstarttime"?: Date;
  "shiftendtime"?: Date;
  "starttime"?: Date;
  "endtime"?: Date;
  "otStarttime"?: Date;
  "otEndtime"?: Date;
  "totalOt": number;
  "autoOvt"?: string;
  "totalOtindex"?: number;
  "companyId": number;
  "remark"?: string;
  "ovtrequestNo"?: string;
  "ovttype"?: string;
  "id"?: number;
}

export class ViewEmpOvtReport implements ViewEmpOvtReportInterface {
  "attendId": string;
  "empId": string;
  "name": string;
  "posName": string;
  "otDate": Date;
  "shiftdailyCode": string;
  "shiftstarttime": Date;
  "shiftendtime": Date;
  "starttime": Date;
  "endtime": Date;
  "otStarttime": Date;
  "otEndtime": Date;
  "totalOt": number;
  "autoOvt": string;
  "totalOtindex": number;
  "companyId": number;
  "remark": string;
  "ovtrequestNo": string;
  "ovttype": string;
  "id": number;
  constructor(data?: ViewEmpOvtReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewEmpOvtReport`.
   */
  public static getModelName() {
    return "ViewEmpOvtReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewEmpOvtReport for dynamic purposes.
  **/
  public static factory(data: ViewEmpOvtReportInterface): ViewEmpOvtReport{
    return new ViewEmpOvtReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewEmpOvtReport',
      plural: 'ViewEmpOvtReports',
      path: 'ViewEmpOvtReports',
      idName: 'id',
      properties: {
        "attendId": {
          name: 'attendId',
          type: 'string'
        },
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "posName": {
          name: 'posName',
          type: 'string'
        },
        "otDate": {
          name: 'otDate',
          type: 'Date'
        },
        "shiftdailyCode": {
          name: 'shiftdailyCode',
          type: 'string'
        },
        "shiftstarttime": {
          name: 'shiftstarttime',
          type: 'Date'
        },
        "shiftendtime": {
          name: 'shiftendtime',
          type: 'Date'
        },
        "starttime": {
          name: 'starttime',
          type: 'Date'
        },
        "endtime": {
          name: 'endtime',
          type: 'Date'
        },
        "otStarttime": {
          name: 'otStarttime',
          type: 'Date'
        },
        "otEndtime": {
          name: 'otEndtime',
          type: 'Date'
        },
        "totalOt": {
          name: 'totalOt',
          type: 'number'
        },
        "autoOvt": {
          name: 'autoOvt',
          type: 'string'
        },
        "totalOtindex": {
          name: 'totalOtindex',
          type: 'number'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "ovtrequestNo": {
          name: 'ovtrequestNo',
          type: 'string'
        },
        "ovttype": {
          name: 'ovttype',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewEmpOvtReport.ts